<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="deleteModalLabel"><!--{{ 'Standard.DeleteConfirmation.Title' | translate }}-->{{ 'Standard.DeleteConfirmation.Text' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-window-close red" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-center"><strong>{{DeletionName}}</strong></div>
    </div>
    <div class="modal-footer">    
      <button type="button" class="btn btn-outline-secondary float-right mt-2" data-dismiss="modal">{{ 'Buttons.Close' | translate }} </button>
      <button type="button" class="btn btn-outline-danger float-left mt-2" (click)="onConfirmation($event)" data-dismiss="modal">{{ 'Buttons.Delete' | translate }}</button>
    </div>
  </div>
</div>
